import React from "react";
import { Box, Container, Typography } from "@mui/material";

const BloodTests = () => {
  return (
    <Box sx={{ py: 4 }}>
      <Container maxWidth="md">
        <Typography variant="h4" gutterBottom color="primary.main">
          Blood Tests (Home Collection)
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          VEM Plus Urgent Care offers convenient and accurate blood testing services right from the comfort of your home. 
          Our professional phlebotomists are trained to collect samples safely and efficiently.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Why Choose Our Home Blood Collection?
        </Typography>
          <Typography variant="body2"component="ul"gutterBottom sx={{ pl: 3, listStyleType: 'disc', marginBottom: '0.5rem' }}>
          <li>Flexible appointments at your convenience</li>
          <li>Safe, hygienic, and quick sample collection</li>
          <li>Faster report turnaround time</li>
          <li>Affordable and transparent pricing</li></Typography> 
      

        <Typography variant="h6" gutterBottom>
          Common Tests We Offer:
        </Typography>
         <Typography variant="body2"component="ul"gutterBottom sx={{ pl: 3, listStyleType: 'disc', marginBottom: '0.5rem' }}>
          <li>Complete Blood Count (CBC)</li>
          <li>Blood Sugar (Fasting/PP)</li>
          <li>Lipid Profile</li>
          <li>Thyroid Profile</li>
          <li>Vitamin D & B12</li>
          <li>Liver & Kidney Function Tests</li>
        </Typography>

        <Typography variant="body1" sx={{ mt: 2 }}>
          Book a test today and experience hassle free diagnostics at your doorstep.
        </Typography>
      </Container>
    </Box>
  );
};

export default BloodTests;
